// extracted by mini-css-extract-plugin
module.exports = {"link-label":"styles_link-label__rFGP3","arrow-icon":"styles_arrow-icon__igjlk","children-container":"styles_children-container__6hJfe"};